
import { defineComponent, onBeforeMount, ref } from 'vue';
import axios, { AxiosError } from 'axios';
import moment from 'moment';
import { getLearnerDetails, getPreAuthUrl, invokeUpdateLearnerStatus, getPreAuthUrlForEvidence } from '@/utils/admin/operation_tab_details_service';
import { invokeGetUserRole } from '@/utils/admin/master_service';
import { downloadLearnerSubmission } from '../../utils/learner_review_service';

export default defineComponent({
  name: 'OperationalTabDetails',
  // props: ['query'],
  props: {
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const learnerTaskId = ref(props.query.learner_task_id);
    const renderReady = ref();
    const getLearner = ref();
    const learnerOtherDetails = ref();
    const preSignedUrl = ref();
    const selectedValue = ref();
    const errorMessage = ref();
    const loggedInUserRoles = ref();
    const showUpdateBtn = ref(false);
    const showSuccessMessage = ref(false);
    const resMessage = ref();
    const showErrorMessage = ref(false);
    const showdonwloadBtn = ref(true);
    const completionDate = ref();
    const passFail = [
      { Id: 'undefined', Name: 'select' },
      { Id: 'Pass', Name: 'Pass' },
      { Id: 'Fail', Name: 'Fail' },
    ];
    const statusName = [
      { Id: 'Not Started', name: 'Not Started' },
      { Id: 'Registered', name: 'Registered' },
      { Id: 'Submitted', name: 'Submitted' },
      { Id: 'Need Reviewer', name: 'Need Reviewer' },
      { Id: 'Need Reviewee', name: 'Need Reviewee' },
      { Id: 'Need Reviewer and Need Reviewee', name: 'Need Reviewer and Need Reviewee' },
      { Id: 'Passed', name: 'Passed' },
      { Id: 'Fail', name: 'Fail' },
      { Id: 'Done', name: 'Done' },
    ];
    const rereviewStatusName = [
      { Id: 'Re-review Accepted Proxy Assigned', name: 'Re-review Accepted Proxy Assigned' },
      { Id: 'Re-review Accepted Proxy Unavailable', name: 'Re-review Accepted Proxy Unavailable' },
      { Id: 'Complete', name: 'Complete' },
    ];
    // console.log('Type of Date', typeof getLearner.value.completion_date);
    const getLearneRecord = async () => {
      try {
        renderReady.value = false;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const res: any = await getLearnerDetails('/learnerDetails', learnerTaskId.value);
        getLearner.value = res.learnerDetails;
        learnerOtherDetails.value = res.otherDetails;
        if (getLearner.value) {
          console.log('Learner Status', getLearner.value.learner_status);
          if (!getLearner.value.re_review_status) getLearner.value.re_review_status = false;
          if (getLearner.value.registration_date) {
            getLearner.value.registration_date = moment(getLearner.value.registration_date).format('YYYY-MM-DD');
          }
          if (getLearner.value.submission_date) {
            getLearner.value.submission_date = moment(getLearner.value.submission_date).format('YYYY-MM-DD');
          }
          if (getLearner.value.completion_date) {
            getLearner.value.completion_date = moment(getLearner.value.completion_date).format('YYYY-MM-DD');
            console.log('completion Date', getLearner.value.completion_date);
          }
          if (getLearner.value.reviewee_assigned_time) {
            getLearner.value.reviewee_assigned_time = moment(getLearner.value.reviewee_assigned_time).format('YYYY-MM-DD');
          }
          if (getLearner.value.re_review_requested_date) {
            getLearner.value.re_review_requested_date = moment(getLearner.value.re_review_requested_date).format('YYYY-MM-DD');
          }
          console.log('status', getLearner.value.learner_status);
          if (getLearner.value.learner_status !== 'Passed' && getLearner.value.learner_status !== 'Fail') {
            console.log('inside status');
            getLearner.value.pass_or_fail = null;
          }
          if (getLearner.value.learner_status === 'Registered' || getLearner.value.learner_status === null) {
            showdonwloadBtn.value = false;
          }
          if (getLearner.value.date_of_technical_hold) {
            getLearner.value.date_of_technical_hold = moment(getLearner.value.date_of_technical_hold).format('YYYY-MM-DD');
          }
        }

        selectedValue.value = getLearner.value.pass_or_fail;
        renderReady.value = true;
      } catch (error) {
        console.log(error);
      }
    };

    const updateRecord = async () => {
      try {
        console.log('Task Completion Date', getLearner.value.completion_date);
        console.log('Task Completion Date', typeof getLearner.value.completion_date);
        if (selectedValue.value === undefined) {
          selectedValue.value = '';
        }
        if (selectedValue.value) {
          getLearner.value.pass_or_fail = selectedValue.value;
        }
        renderReady.value = false;
        // const data = {
        //   learner_task_id: getLearner.value.learner_task_id,
        //   learner_status: getLearner.value.learner_status,
        //   task_reviewer_count: getLearner.value.task_reviewer_count,
        //   task_reviewee_count: getLearner.value.task_reviewee_count,
        //   aggregated_grade: getLearner.value.aggregated_grade,
        //   pass_or_fail: selectedValue.value,
        // };
        // console.log('Get Learner Value with utc', moment(getLearner.value.completion_date).utc().format());
        // console.log('Get Learner Value without utc', getLearner.value.completion_date);
        getLearner.value.completion_date = moment(getLearner.value.completion_date).utc().format();
        // console.log('Data for update', data);

        console.log('Get Learner Value with utc', getLearner.value);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const updateRes: any = await invokeUpdateLearnerStatus('/updateLearnerJourney', getLearner.value);
        // console.log('Response', updateRes);
        await getLearneRecord();
        renderReady.value = true;
        resMessage.value = updateRes;
        // console.log('Response', resMessage.value);
        showSuccessMessage.value = true;
        setTimeout(() => {
          showSuccessMessage.value = false;
        }, 6000);
      } catch (error) {
        if (axios.isAxiosError(error)) {
          const err = error as AxiosError;
          console.log(err.response?.data);
          renderReady.value = true;
          resMessage.value = (err.response?.data as { message: string })?.message;
          console.log(`errorMessage.value ${errorMessage.value}`);
          showErrorMessage.value = true;
          setTimeout(() => {
            showErrorMessage.value = false;
          }, 6000);
        }
      }
    };
    const learnerSubmissionClicked = async () => {
      try {
        const data = {
          file_name: getLearner.value.learner_submission,
          task_id: getLearner.value.learner_task_id,
        };
        renderReady.value = false;
        // preSignedUrl.value = await getPreAuthUrl('/v1/pretAuthUrlForDownload', data);
        preSignedUrl.value = await getPreAuthUrl('/v1/pretAuthUrlForDownload', data);
        await downloadLearnerSubmission(preSignedUrl.value, getLearner.value.learner_submission);
        renderReady.value = true;
      } catch (error) {
        console.log('Save Task Data', error);
      }
    };
    const plagiarismEvidenceClicked = async () => {
      try {
        let plagiarismEvidenceFileName = getLearner.value.plagiarism_evidence;
        if (plagiarismEvidenceFileName && plagiarismEvidenceFileName.endsWith('PNG')) {
          const fileName = plagiarismEvidenceFileName.split('.')[0];
          plagiarismEvidenceFileName = `${fileName}.png`;
        }
        console.log(`plagiarismEvidenceFileName ${plagiarismEvidenceFileName}`);
        const data = {
          file_name: plagiarismEvidenceFileName,
          task_id: getLearner.value.learner_task_id,
        };
        renderReady.value = false;
        // preSignedUrl.value = await getPreAuthUrl('/v1/pretAuthUrlForDownload', data);
        preSignedUrl.value = await getPreAuthUrlForEvidence('/v1/pretAuthUrlForEvidenceDownload', data);
        await downloadLearnerSubmission(preSignedUrl.value, plagiarismEvidenceFileName);
        renderReady.value = true;
      } catch (error) {
        console.log('Save Task Data', error);
      }
    };
    onBeforeMount(async () => {
      // completionDate.value = '2017-07-04';
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const role: any = await invokeGetUserRole('/getUserRole');
      loggedInUserRoles.value = role.user_roles;
      if (loggedInUserRoles.value.length > 0) {
        if (loggedInUserRoles.value.includes('System Admin')) {
          showUpdateBtn.value = true;
        }
      } else {
        showUpdateBtn.value = false;
      }
      await getLearneRecord();
    });
    return {
      renderReady,
      getLearner,
      preSignedUrl,
      selectedValue,
      passFail,
      updateRecord,
      errorMessage,
      learnerSubmissionClicked,
      loggedInUserRoles,
      showUpdateBtn,
      statusName,
      showSuccessMessage,
      resMessage,
      showErrorMessage,
      showdonwloadBtn,
      completionDate,
      learnerOtherDetails,
      rereviewStatusName,
      plagiarismEvidenceClicked,
    };
  },
});
